"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentUser = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var utils_1 = require("../utils");
/**
 * Hook allowing to get current user details
 * @param config - configuration of the hook
 * @internal
 */
function useCurrentUser(_a) {
    var backend = _a.backend, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    utils_1.backendInvariant(effectiveBackend, "useCurrentUser");
    var promise = function () { return effectiveBackend.currentUser().getUser(); };
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
    ]);
}
exports.useCurrentUser = useCurrentUser;
//# sourceMappingURL=useCurrentUser.js.map